/* global elementorFrontend, Swiper */
import $ from 'jquery';

const LogoMarquee = () => {
	let initialized = false;

	const init = () => {
		if (initialized) return;
		initialized = true;

		const el = document.querySelector('.logo-marquee.swiper');
		if (!el) return;
		if (el.swiper) return;
		if (typeof window.Swiper === 'undefined') return;

		const SwiperInstance = window.Swiper;

		new SwiperInstance(el, {
			loop: true,
			slidesPerView: 'auto',
			spaceBetween: 10,
			speed: 8000,

			allowTouchMove: false,
			simulateTouch: false,
			grabCursor: false,

			autoplay: {
				delay: 1,
				disableOnInteraction: false,
				pauseOnMouseEnter: false,
				waitForTransition: false,
			},

			observer: false,
			observeParents: false,
			watchSlidesProgress: false,
			freeMode: false,
			freeModeMomentum: false,
		});
	};

	const initElementor = () => {
		if (window.elementorFrontend?.hooks) {
			window.elementorFrontend.hooks.addAction(
				'frontend/element_ready/global',
				() => init(),
			);
		}
	};

	const boot = () => {
		init();
		initElementor();
	};

	boot();
};

try {
	$(function () {
		LogoMarquee();
	});
} catch (error) {
	console.error('LogoMarquee error:', error);
}
